import Input from "components/form/Input";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { getCategorySalesReportFilteredData } from "../../services/salesReportsServices";

export default function FilterModal({ onClose, data }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [filteredData, setFilteredData] = useState(data);

  // Filter Data
  const [filterCriteria, setFilterCriteria] = useState({
    Category: "",
  });

  const handleFilterCategoryReports = (e) => {
    e.preventDefault();
    const filteredResult = data.filter((item) => {
      const { Category } = filterCriteria;

      let filterCategory= true;

      if (Category) {
        filterCategory = item?.Category?.toLowerCase().includes(Category.toLowerCase());
      }

      return (
        filterCategory
      );

    });

    setFilteredData(filteredResult);
    onClose();
    dispatch(getCategorySalesReportFilteredData(filteredResult));
  };

  return (
    <>
      <GModal
        onClose={onClose}
        modalHeader={t("pages.reports.business_reports.filter")}
        modalContent={
          <Box p={4}>
            <form onSubmit={handleFilterCategoryReports}>
              <Stack spacing={6}>
                <Input
                  label={t("pages.reports.reports_tables.category")}
                  labelStyle={{ textTransform: "capitalize" }}
                  placeholder={t("pages.reports.reports_tables.category")}
                  name="Category"
                  value={filterCriteria.Category}
                  onChange={(e) =>
                    setFilterCriteria({
                      ...filterCriteria,
                      Category: e.target.value,
                    })
                  }
                />

                <Flex gap={4}>
                  <GButton
                    type="submit"
                    title={t("general.save")}
                    bg="primary"
                    color="light"
                    border="1px solid transparent"
                    hover={{
                      color: "primary",
                      borderColor: "primary",
                      bg: "none",
                    }}
                  />
                  <GButton
                    title={t("general.close")}
                    onClick={onClose}
                    bg="red.600"
                    border="1px solid transparent"
                    color="light"
                    hover={{
                      color: "red.600",
                      borderColor: "red.600",
                      bg: "none",
                    }}
                  />
                </Flex>
              </Stack>
            </form>
          </Box>
        }
      />
    </>
  );
};